<template>
  <div>
    <!--    FILTERS-->
    <div class="filters-container">
      <!--      YEAR-->
      <b-select
        v-model="selection.year" :options="yearOptions()"
      />
      <!--      REGION-->
      <b-select
        v-model="selection.region" :options="regionOptions()"
      />
      <!--      COUNTRY-->
      <b-select
        v-model="selection.country" :options="countryOptions()"
      />
      <!--      ACTIVITY-->
      <b-select
        v-model="selection.activity" :options="activityOptions()"
      />
      <!--      SIZE-->
      <b-select
        v-model="selection.size" :options="sizeOptions()"
      />
    </div>

    <!--    END FILTERS-->
    <div class="widgets-container">
      <div
        v-for="(chart, chartIndex) of dashboardWidgets"
        :key="chartIndex"
        class="widgets-outer-padding"
      >
        <div
          v-if="chart.data" class="widget-container"
        >
          <div v-bind:class="chart.isGBV ? 'widget-title-gbv' : 'widget-title'">
            {{ $t(chart.title) }}
          </div>
          <div class="dashboard-widget-center">
            <div>
              <dashboard-pie
                v-if="chart.type === 'pie'"
                :key="chart.name"
                :alias="chart.name"
                :chart-data="chart.data"
                :subtitle="chart.subtitle"
              />
              <dashboard-gender
                v-if="chart.type === 'gender'"
                :chart-data="chart.data"
              />

              <dashboard-chart-vertical
                v-if="chart.type === 'vertical'"
                :key="chart.name"
                :alias="chart.name"
                :chart-data="chart.data"
                subtitle="label_dashboard_size_numberOfEmployees"
              />
              <dashboard-status-temp
                v-if="chart.type === 'status'"
                :key="chart.name"
                :chart-data="chart.data"
                subtitle="label_dashboard_size_numberOfEmployees"
              >
              </dashboard-status-temp>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosCall} from "@/utils/axiosCall";
import DashboardPie from "@/components/modules/dashboard/components/generic-charts/dashboard-pie.vue";
import DashboardGender from "@/components/modules/dashboard/components/generic-charts/dashboard-gender.vue";
import DashboardChartVertical
  from "@/components/modules/dashboard/components/generic-charts/dashboard-chart-vertical.vue";
import DashboardStatusTemp from "@/components/modules/dashboard/components/generic-charts/dashboard-status-temp.vue";
import DashboardStatus from "@/components/modules/dashboard/components/generic-charts/dashboard-status.vue";
import BarChart from "@/shared/charts/bar-char/bar-chart.vue";

export default {
  name: "Dashboard",
  components: {BarChart, DashboardStatusTemp, DashboardStatus, DashboardChartVertical, DashboardPie, DashboardGender},
  data: function () {
    return {
      dashboardFiltersData: [],
      selection: {
        year: null,
        country: null,
        activity: null,
        size: null,
        region: null
      },
      colors: [
        "#19A39C",
        "#F22574",
        "#B7C600",
        "#01C2E5",
        "#FFA700",
        "#CE51BF",
        "#2BA805",
        "#8819A3",
        "#EAD325",
        "#22E21A",
        "#19A39C",
        "#F22574",
        "#B7C600",
        "#01C2E5",
        "#FFA700",
        "#CE51BF",
        "#2BA805",
        "#8819A3",
        "#EAD325",
        "#22E21A",
        "#19A39C",
        "#F22574",
        "#B7C600",
        "#01C2E5",
        "#FFA700",
        "#CE51BF",
        "#2BA805",
        "#8819A3",
        "#EAD325",
        "#22E21A",
        "#19A39C",
        "#F22574",
        "#B7C600",
        "#01C2E5",
        "#FFA700",
        "#CE51BF",
        "#2BA805",
        "#8819A3",
        "#EAD325",
        "#22E21A",
      ],
      dashboardWidgets: [],
    };
  },
  watch: {
    selection: {
      handler: async function () {
       await this.fetchFilters();
        await this.fetchDashboard();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.fetchFilters();
    await this.fetchDashboard();
  },
  methods: {
    regionOptions() {
      return [
        {text: this.$t("label_dashboard_filterBy_region"), value: null},
        ...(this.dashboardFiltersData.region || [])
          .filter((region) => !!region?.id)
          .map((region) => ({
            value: region.id,
            text: this.$t(region.name),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];
    },
    yearOptions() {
      // YEAR
      return [
        {text: this.$t("label_dashboard_filterBy_year"), value: null},
        ...(this.dashboardFiltersData.year || []).sort().map((year) => ({
          text: year,
          value: year,
        })),
      ];
    },
    countryOptions() {
      // COUNTRY
      return [
        {text: this.$t("label_dashboard_filterBy_country"), value: null},

        ...(this.dashboardFiltersData.country || [])
          .map((country) => ({
            value: country.id,
            text: this.$t(country.name),
          }))
          .sort((countryA, countryB) =>
            countryA.text.localeCompare(countryB.text)
          ),
      ];
    },
    activityOptions() {
      // ACTIVITY
      return [
        {text: this.$t("label_dashboard_filterBy_activity"), value: null},

        ...(this.dashboardFiltersData.activity || [])
          .filter((activity) => !!activity)
          .map((activity) => ({
            value: activity,
            text: this.$t(activity),
          }))
          .sort((activityA, activityB) =>
            activityA.text.localeCompare(activityB.text)
          ),
      ];

    },
    sizeOptions() {
      // SIZE
      return [
        {text: this.$t("label_dashboard_filterBy_size"), value: null},
        ...(this.dashboardFiltersData.size || [])
          .filter((size) => !!size)
          .map((size) => ({
            value: size,
            text: this.$t(size),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];

    },
    resetData() {
      this.dashboardWidgets = [
        {
          name: "status",
          type: "status",
          data: {},
          title: "label_dashboard_widget_title_status",
        },
        {
          name: "impacted-workers",
          type: "gender",
          data: {},
          title: "label_dashboard_widget_title_impactedWorkers",
        },
        {
          name: "region",
          type: "pie",
          data: [],
          title: "label_dashboard_widget_title_region",
        },
        {
          name: "organization-type",
          type: "pie",
          data: [],
          title: "label_dashboard_widget_title_type",
        },
        {
          name: "economic-sector",
          type: "pie",
          data: [],
          title: "label_dashboard_widget_title_economicSector",
        },
        {
          name: "size",
          type: "vertical",
          data: [],
          title: "label_dashboard_widget_title_size",
        },
        {
          name: "employees-surveyed",
          type: "gender",
          data: {},
          title: "label_dashboard_widget_title_employeesSurveyed",
        },
        {
          name: "demographic-age",
          type: "pie",
          data: {},
          title: "label_dashboard_widget_title_surveyDemographics",
          subtitle: "label_dashboard_demographics_byAge",
        },
        {
          name: "demographic-race",
          type: "pie",
          data: {},
          title: "label_dashboard_widget_title_surveyDemographics",
          subtitle: "label_dashboard_demographics_byRace",
        },
        {
          name: "gbv-employees-surveyed",
          type: "gender",
          data: {},
          title: "label_dashboard_widget_title_gbvEmployeesSurveyed",
          isGBV:true
        },
        {
          name: "demographic-age-gbv",
          type: "pie",
          data: {},
          title: "label_dashboard_widget_title_gbvSurveyDemographics",
          subtitle: "label_dashboard_demographics_byAge",
          isGBV:true
        },
        {
          name: "demographic-race-gbv",
          type: "pie",
          data: {},
          title: "label_dashboard_widget_title_gbvSurveyDemographics",
          subtitle: "label_dashboard_demographics_byRace",
          isGBV:true
        },
      ];
    },
    fetchFilters: async function () {


      var dashboardFiltersData = await axiosCall({
        url: "dashboard/get-filter-options",
        method: "POST",
        data: this.selection
      });

      this.dashboardFiltersData.region = dashboardFiltersData.data[0].region;
      this.dashboardFiltersData.year = dashboardFiltersData.data[0].year;
      this.dashboardFiltersData.country = dashboardFiltersData.data[0].country;
      this.dashboardFiltersData.activity = dashboardFiltersData.data[0].activity;
      this.dashboardFiltersData.size = dashboardFiltersData.data[0].size;


    },
    fetchDashboard: async function () {
      var dashboardData = await axiosCall({
        url: "dashboard",
        method: "POST",
        data: this.selection,
      });
      this.resetData();

      this.processStatusData(dashboardData);
      this.processImpactedWorkersData(dashboardData);
      this.processRegionData(dashboardData);
      this.processOrganizationTypeData(dashboardData);
      this.processEconomicSectorData(dashboardData);
      this.processSizeData(dashboardData);
      this.processEmployeeSurveyedData(dashboardData);
      this.processDemographicAgeData(dashboardData);
      this.processDemographicRaceData(dashboardData);
      this.processGbvEmployeesSurveyedData(dashboardData);
      this.processDemographicAgeDataGbv(dashboardData);
      this.processDemographicRaceDataGbv(dashboardData);
    },
    processStatusData(dashboardData) {
      var arrData = dashboardData.data?.businessStatus;
      if (arrData.length) {
        var data = arrData;
        this.dashboardWidgets.find(
          (widget) => widget.name === "status"
        ).data = {
          data,
        };
      }
      this.dashboardWidgets.find(
        (widget) => widget.name === "status"
      ).data.total =dashboardData.data.totalOfCompanies
    },
    processImpactedWorkersData(dashboardData) {
      var arrData = dashboardData.data?.impactedWorkers;
      if (arrData.length) {
        var data = arrData[0];
        var total = data.women + data.men;
        this.dashboardWidgets.find(
          (widget) => widget.name === "impacted-workers"
        ).data = {
          women: data.women,
          pWomen:  (100 * data.women) / total,
          men: data.men,
          pMen: (100 * data.men) / total,
          total,
        };
      }
    },
    processRegionData(dashboardData) {
      var totalRegions = dashboardData.data?.regions?.reduce(
        (total, business) => business.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "region").data = dashboardData.data?.regions
        ?.map((region) => ({
          value: region.count,
          label: region._id,
          percentage: region.count / totalRegions,
        }))
        .sort(
          (regionA, regionB) => regionB.percentage - regionA.percentage
        )
        .map((region, index) => ({
          ...region,
          color: this.colors[index],
        }));
    },
    processOrganizationTypeData(dashboardData) {
      var totalOrganizationTypes = dashboardData.data?.businessType?.reduce(
        (total, business) => business.count + total,
        0
      );
      this.dashboardWidgets.find(
        (widget) => widget.name === "organization-type"
      ).data = dashboardData.data?.businessType
        ?.map((business) => ({
          value: business.count,
          label: business._id,
          percentage: business.count / totalOrganizationTypes,
        }))
        .sort(
          (businessA, businessB) => businessB.percentage - businessA.percentage
        )
        .map((business, index) => ({
          ...business,
          color: this.colors[index],
        }));
    },
    processEconomicSectorData(dashboardData) {
      var totalEconomicSectors = dashboardData.data?.economicSector?.reduce(
        (total, economicSector) => economicSector.count + total,
        0
      );
      this.dashboardWidgets.find(
        (widget) => widget.name === "economic-sector"
      ).data = dashboardData.data?.economicSector
        ?.map((economicSector) => ({
          value: economicSector.count,
          label: economicSector._id,
          percentage: economicSector.count / totalEconomicSectors,
        }))
        .sort(
          (economicSectorA, economicSectorB) =>
            economicSectorB.percentage - economicSectorA.percentage
        )
        .map((economicSector, index) => ({
          ...economicSector,
          color: this.colors[index],
        }));
    },
    processSizeData(dashboardData) {
      var totalSizes = dashboardData.data?.size?.reduce(
        (total, size) => size.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "size").data =
        dashboardData.data?.size
          ?.map((size) => ({
            value: size.count,
            label: size._id,
            percentage: size.count / totalSizes,
            type: 'integer'
          }))
          .sort((sizeA, sizeB) => sizeB.percentage - sizeA.percentage)
          .map((size, index) => ({
            ...size,
            color: this.colors[index],
          }));
    },
    processEmployeeSurveyedData(dashboardData) {
      var arrData = dashboardData.data?.employeesSurveyed;
      if (arrData.length) {
        var men = 0;
        var women = 0;
        arrData.forEach((data) => {
          if (
            data._id === "optionList_opinionSurvey_basicInformation_qA_sex_male"
          ) {
            men = data.count;
          }
          if (
            data._id ===
            "optionList_opinionSurvey_basicInformation_qA_sex_female"
          ) {
            women = data.count;
          }
        });
        var total = women + men;
        this.dashboardWidgets.find(
          (widget) => widget.name === "employees-surveyed"
        ).data = {
          women: women,
          pWomen: (100 * women) / total,
          men: men,
          pMen: (100 * men) / total,
          total,
        };
      }
    },
    processDemographicAgeData(dashboardData) {
      var totalAges = dashboardData.data?.demographicAge?.reduce(
        (total, size) => size.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "demographic-age").data =
        dashboardData.data?.demographicAge
          ?.map((demographicAge) => ({
            value: demographicAge.count,
            label: demographicAge._id,
            percentage: demographicAge.count / totalAges,
            type: 'integer'
          }))
          .sort((demographicAgeA, demographicAgeB) => {
            if(demographicAgeA.label?.includes('under') && !demographicAgeB.label?.includes('under')){
              return -1
            }
            if(demographicAgeB.label?.includes('under') && !demographicAgeA.label?.includes('under')){
              return 1
            }

            if(demographicAgeA.label?.includes('older') && !demographicAgeB.label?.includes('older')){
              return 1
            }
            if(demographicAgeB.label?.includes('older') && !demographicAgeA.label?.includes('older')){
              return -1
            }
            return demographicAgeA.label.localeCompare(demographicAgeB.label)

          })
          .map((size, index) => ({
            ...size,
            color: this.colors[index],
          }));
    },
    processDemographicRaceData(dashboardData) {
      var totalRaces = dashboardData.data?.demographicRace?.reduce(
        (total, size) => size.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "demographic-race").data =
        dashboardData.data?.demographicRace
          ?.map((demographicRace) => ({
            value: demographicRace.count,
            label: demographicRace._id,
            percentage: demographicRace.count / totalRaces,
            type: 'integer'
          }))
          .sort((demographicRaceA, demographicRaceB) => demographicRaceB.percentage - demographicRaceA.percentage)
          .map((size, index) => ({
            ...size,
            color: this.colors[index],
          }));
    },
    processGbvEmployeesSurveyedData(dashboardData) {
      var arrData = dashboardData.data?.employeesSurveyedGbv;

      if (arrData.length) {
        var men = 0;
        var women = 0;
        arrData.forEach((data) => {
          if (
            data._id === "optionList_opinionSurvey_basicInformation_qA_sex_male"
          ) {
            men = data.count;
          }
          if (
            data._id ===
            "optionList_opinionSurvey_basicInformation_qA_sex_female"
          ) {
            women = data.count;
          }
        });
        var total = women + men;
        this.dashboardWidgets.find(
          (widget) => widget.name === "gbv-employees-surveyed"
        ).data = {
          women: women,
          pWomen: (100 * women) / total,
          men: men,
          pMen: (100 * men) / total,
          total,
        };
      }
    },
    processDemographicAgeDataGbv(dashboardData) {
      var totalAges = dashboardData.data?.demographicAgeGbv?.reduce(
        (total, size) => size.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "demographic-age-gbv").data =
        dashboardData.data?.demographicAgeGbv
          ?.map((demographicAge) => ({
            value: demographicAge.count,
            label: demographicAge._id,
            percentage: demographicAge.count / totalAges,
            type: 'integer'
          }))
          .sort((demographicAgeA, demographicAgeB) => {
            if(demographicAgeA.label?.includes('under') && !demographicAgeB.label?.includes('under')){
              return -1
            }
            if(demographicAgeB.label?.includes('under') && !demographicAgeA.label?.includes('under')){
              return 1
            }

            if(demographicAgeA.label?.includes('older') && !demographicAgeB.label?.includes('older')){
              return 1
            }
            if(demographicAgeB.label?.includes('older') && !demographicAgeA.label?.includes('older')){
              return -1
            }
            return demographicAgeA.label.localeCompare(demographicAgeB.label)

          })
          .map((size, index) => ({
            ...size,
            color: this.colors[index],
          }));
    },
    processDemographicRaceDataGbv(dashboardData) {
      var totalRaces = dashboardData.data?.demographicRaceGbv?.reduce(
        (total, size) => size.count + total,
        0
      );
      this.dashboardWidgets.find((widget) => widget.name === "demographic-race-gbv").data =
        dashboardData.data?.demographicRaceGbv
          ?.map((demographicRace) => ({
            value: demographicRace.count,
            label: demographicRace._id,
            percentage: demographicRace.count / totalRaces,
            type: 'integer'
          }))
          .sort((demographicRaceA, demographicRaceB) => demographicRaceB.percentage - demographicRaceA.percentage)
          .map((size, index) => ({
            ...size,
            color: this.colors[index],
          }));
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-container {
  display: flex;
  gap: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  flex-wrap: wrap;

  > * {
    flex-basis: 200px;
    flex-grow: 0;
  }

  justify-content: center;
}

.widget-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #1e4381;
  background-color: #f8fcff;
  color: black;
  height: 100%;
}

.widget-title {
  background-color: #1e4381;
  text-align: center;
  font-size: 1rem;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Poppins-SemiBold";
  padding: 5px 0;
}

.widget-title-gbv {
  background-color: #7030A0;
  text-align: center;
  font-size: 1rem;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Poppins-SemiBold";
  padding: 5px 0;
}

.widgets-outer-padding {
  padding: 20px;
}

.widgets-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 1450px;
  margin: 0 auto;
  justify-content: center;

  > * {
    flex-basis: calc(100% / 3);
    max-width: calc(100% / 3);
    flex-grow: 0;
    flex-shrink: 0;
    height: auto;
  }

  @media screen and (max-width: 1350px) {
    > * {
      flex-basis: calc(100% / 2);
      max-width: calc(100% / 2);
      flex-grow: 0;
      flex-shrink: 0;
      height: auto;
    }
  }

  @media screen and (max-width: 1000px) {
    > * {
      flex-basis: calc(100%);
      max-width: 650px;
      flex-grow: 0;
      flex-shrink: 0;
      height: auto;
    }
  }
}

.dashboard-widget-center {
  padding: 15px 0px;
  height: 100%;
  display: flex;
  align-items: center;

  > * {
    flex-grow: 1;
    flex-basis: 100%;
  }
}
</style>

